module.exports = __webpack_public_path__ + "static/media/playskillsa30f8352.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/categories/playskills.svg
// module id = 1334
// module chunks = 0